import { rootApi } from '../../services/rootApi';
import { postApi } from '../../utils/urls';
import { notifySuccess, notifyError } from '../../services/notifications';
import i18next from "i18next";

// Discussion API using RTKQ
export const discussionApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    sendMessage: builder.mutation({
      query: ({ data }) => ({
        url: postApi(),
        method: 'POST',
        body: {
          data: {
            parentId: data.parentId,
            body: data.body
          },
          method: 'create'
        },
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          notifySuccess(i18next.t('coursePage.discussion.sent'));
        } catch (error) {
          notifyError(error.error?.data?.errMsg || 'Failed to send message');
        }
      },
      invalidatesTags: ['Discussion'],
    }),
    
    editMessage: builder.mutation({
      query: ({ id, content }) => ({
        url: postApi(),
        method: 'POST',
        body: {
          data: { id, body: content },
          method: 'update'
        },
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          notifySuccess(i18next.t('coursePage.discussion.edited'));
        } catch (error) {
          notifyError(error.error?.data?.errMsg || 'Failed to edit message');
        }
      },
      invalidatesTags: (result, error, { id }) => [{ type: 'Post', id }],
    }),
    
    deleteMessage: builder.mutation({
      query: ({ id }) => ({
        url: postApi(),
        method: 'POST',
        body: {
          data: { id },
          method: 'delete'
        },
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          notifySuccess(i18next.t('coursePage.discussion.deleted'));
        } catch (error) {
          notifyError(error.error?.data?.errMsg || 'Failed to delete message');
        }
      },
      invalidatesTags: (result, error, { id }) => [{ type: 'Post', id }],
    }),
    
    toggleFollow: builder.mutation({
      query: ({ postId, method }) => ({
        url: postApi(),
        method: 'POST',
        body: {
          data: { postId },
          method: method
        },
      }),
      async onQueryStarted({ method }, { queryFulfilled }) {
        try {
          await queryFulfilled;
          const message = method === 'follow' 
            ? i18next.t('coursePage.discussion.follow') 
            : i18next.t('coursePage.discussion.unfollow');
          notifySuccess(message);
        } catch (error) {
          notifyError(error.error?.data?.errMsg || 'Failed to toggle follow');
        }
      },
      invalidatesTags: (result, error, { postId }) => [{ type: 'Post', id: postId }],
    }),
  }),
});

export const {
  useSendMessageMutation,
  useEditMessageMutation,
  useDeleteMessageMutation,
  useToggleFollowMutation,
} = discussionApiSlice;
